import * as runtime from '../runtime';
import { IInitializeServiceOptions } from '../types';
import { IGetAgentDetailsRequest, IGetAgentDetailsResponse } from './models';

export class AgentService extends runtime.BaseAPI {
	constructor(
		configuration: runtime.Configuration,
		private tenantId: string,
	) {
		super(configuration);
	}

	async getAgentDetailsRaw(
		requestParameters: IGetAgentDetailsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction,
	): Promise<runtime.ApiResponse<IGetAgentDetailsResponse>> {
		if (requestParameters.agentId === null || requestParameters.agentId === undefined) {
			throw new runtime.RequiredError('agentId', 'Required parameter requestParameters.agentId was null or undefined when calling getAgentDetailsRaw.');
		}

		const queryParameters: runtime.HTTPQuery = {};
		const headerParameters: runtime.HTTPHeaders = {};
		const response = await this.request(
			{
				path: `/api/v2/agent/${requestParameters.agentId} `,
				method: 'GET',
				headers: headerParameters,
				query: queryParameters,
			},
			initOverrides,
		);

		return new runtime.JSONApiResponse(response);
	}

	async getAgentDetails(
		requestParameters: IGetAgentDetailsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction,
	): Promise<IGetAgentDetailsResponse> {
		const response = await this.getAgentDetailsRaw(requestParameters, initOverrides);
		return response.value();
	}
}

export const initializeAgentService = ({ fetchApi, serviceBaseURLs, tenantId }: Required<IInitializeServiceOptions>) => {
	const agentService = new AgentService(
		new runtime.Configuration({
			fetchApi,
			basePath: serviceBaseURLs.runtime,
		}),
		tenantId,
	);

	return agentService;
};
